<script>
import TgIconButton from "@/abc-dsk/components/IconButton/TgIconButton.vue";
import ActionWithTooltip from "@/components/ActionWithTooltip.vue";
import IconImage from "@/components/icons/IconImage.vue";
import IconImageFilled from "@/components/icons/IconImageFilled.vue";

export default {
  name: "ImageButton",
  components: {
    ActionWithTooltip,
    IconImage,
    IconImageFilled,
    TgIconButton
  },
  props: {
    currentActiveIllustrationUrl: {
      type: String,
      default: ""
    },
    illustrations: {
      type: Array,
      required: true
    },
    buttonClass: {
      type: String,
      default: undefined
    }
  },
  emits: ["illustrationUrlUpdate", "mouseover", "mouseout"],
  methods: {
    changeIllustration(illustrationUrl) {
      const newIlllustrationUrl =
        this.currentActiveIllustrationUrl === illustrationUrl ? "" : illustrationUrl;
      this.$emit("illustrationUrlUpdate", newIlllustrationUrl);
    },

    isActive(illustrationUrl) {
      return this.currentActiveIllustrationUrl === illustrationUrl;
    }
  }
};
</script>

<template>
  <ActionWithTooltip
    v-for="(illustrationUrl, index) in illustrations"
    :key="index"
    :show-success="isActive(illustrationUrl)"
    :class="[buttonClass]"
    hide-on-click
  >
    <template #element>
      <TgIconButton
        color="yellow"
        :aria-label="$t('article.illustration.label')"
        @mouseover="$emit('mouseover', $event)"
        @mouseout="$emit('mouseout', $event)"
        @click.stop="changeIllustration(illustrationUrl)"
      >
        <IconImageFilled v-if="isActive(illustrationUrl)" role="presentation" />
        <IconImage v-else role="presentation" />
      </TgIconButton>
    </template>
    <template #actionSuccess>{{ $t("article.actions.image.close") }}</template>
    <template #actionInitial>{{ $t("article.actions.image.open") }}</template>
  </ActionWithTooltip>
</template>
